export default {
  USE_DOMAIN: 'use-domain',
  GET_FREE_DOMAIN: 'get-free-subdomain',
  BUY_DOMAIN: 'buy-domain',
  EXISTING_DOMAIN: 'existing-domain',
  THIRD_PARTY_DOMAIN: 'third-party-domain',
};
